import React from 'react'
import i18next from 'i18next'
import { PaymentMetadata } from 'types/transaction'
import { TransactionDetailRow } from '../TransactionDetailRow'
import CopyTransactionRow from './CopyTransactionRow'

interface PaymentInProps {
  amountWithCurrency: string
  paidActualAmountWithCurrency: string
  transactionReference: string
  merchantId: string
  sourceAddress: string
  paymentMetadata?: PaymentMetadata
  currencyFrom?: string
  currencyTo?: string
}

const PaymentIn = ({
  amountWithCurrency,
  paidActualAmountWithCurrency,
  transactionReference,
  merchantId,
  sourceAddress,
  paymentMetadata,
  currencyFrom,
  currencyTo,
}: PaymentInProps) => {
  return (
    <>
      {amountWithCurrency && (
        <TransactionDetailRow
          label={i18next.t('transactions.sideBar.paymentOutAmountPaid')}
          detail={amountWithCurrency}
        />
      )}
      {paidActualAmountWithCurrency && (
        <TransactionDetailRow
          label={i18next.t('transactions.sideBar.actualAmountPaid')}
          detail={paidActualAmountWithCurrency}
        />
      )}
      {sourceAddress && (
        <CopyTransactionRow
          content={sourceAddress}
          label={i18next.t('transactions.sideBar.sourceAddress')}
        />
      )}
      {merchantId && (
        <TransactionDetailRow
          label={i18next.t('transactions.sideBar.merchantId')}
          detail={merchantId}
        />
      )}
      {transactionReference && (
        <CopyTransactionRow
          content={transactionReference}
          label={i18next.t('transactions.sideBar.reference')}
        />
      )}
      {paymentMetadata?.exchangeRate && (
        <TransactionDetailRow
          label={i18next.t('wallets.searchTransaction.exchangeRate')}
          detail={`1 ${currencyFrom} = ${paymentMetadata?.exchangeRate} ${currencyTo}`}
        />
      )}
    </>
  )
}

export default PaymentIn
